import { LoginFormLayout } from "../../layouts/LoginFormLayout/LoginFormLayout";
import { Typography } from "antd";
import React from "react";

import classes from "./style/Documents.module.css";

const { Title, Text } = Typography;

/**
 * Компонент отображает полный текст соглашения на обработку персональных данных
 * с информацией о целях обработки данных, перечне обрабатываемых персональных данных,
 * действиях с ними и сроках действия согласия.
 */
export function AgreementPersonalDataProcessingDocument(): JSX.Element {
  return (
    <LoginFormLayout
      childrenContainerClassName={classes.childrenContainerClassName}
      className={classes.documentLayout}
      showSupportText={false}
    >
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <Title className={classes.documentHeader} level={1}>
            СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
          </Title>
          <p className={classes.textIndent}>
            <Text className={classes.sectionText}>
              Я свободно, своей волей и в своём интересе даю
              <strong>«Айти Онлайн»</strong>
              (ИНН 1686007432, ОГРН 1221600022423, юридический адрес: Российская
              Федерация, 420029, Республика Татарстан, г. Казань, ул Сибирский
              Тракт, зд. 34 к. 1, помещ. 1002 офис 1) (далее – «Оператор»),
              согласие на обработку моих персональных данных, полученных
              Оператором через форму регистрации на сайте{" "}
              <a
                href="https://tatbg.ru/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://tatbg.ru/
              </a>
              , в соответствии со статьей 9 Федерального закона от 27.07.2006
              №152-ФЗ «О персональных данных» на следующих условиях:
            </Text>
          </p>
          <p className={classes.textIndent}>
            <Text className={classes.sectionText}>
              {"   "}
              <strong>Цели обработки персональных данных:</strong>
            </Text>
          </p>

          <ul className={classes.markList}>
            <li className={classes.markListItem}>
              <Text>
                предоставление доступа субъекту персональных данных к личному
                кабинету, а также к сервисам, информации и/или материалам,
                содержащимся на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                проведение консультаций по вопросам, касающихся, сервисов,
                информации и материалов, содержащихся на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                осуществление посреднических услуг зарегистрированным
                пользователям на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                направление информационных электронных писем субъекту
                персональных данных;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                улучшение функционирования сайта и проведения статистических
                исследований.
              </Text>
            </li>
          </ul>
          <p className={classes.textIndent}>
            <Text className={classes.sectionText}>
              <strong>
                Перечень персональных данных, на обработку которых я даю
                согласие:
              </strong>
            </Text>
          </p>

          <ul className={classes.markList}>
            <li className={classes.markListItem}>
              <Text>фамилия, имя, отчество (при наличии);</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                паспортные данные единоличного исполнительного органа (включая
                генерального директора) юридического лица, а также учредителей
                юридического лица;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                адрес регистрации места жительства учредителей юридического
                лица, а также единоличного исполнительного органа;
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>ИНН</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                страховой номер индивидуального лицевого счета застрахованного
                лица (СНИЛС);
              </Text>
            </li>

            <li className={classes.markListItem}>
              <Text>номер мобильного телефона;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>адрес электронной почты (e-mail);</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>файлы cookie.</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                прочие сведения, которые могут идентифицировать пользователя и
                сообщены пользователем Оператору.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Субъект персональных данных, представляющий интересы
                юридического лица гарантирует, что предоставляемые персональные
                данные субъектов такого юридического лица (единоличный
                исполнительный орган, учредители юридического лица, иные лица,
                уполномоченные юридическим лицом) являются корректными и
                актуальными, получены и передаются Оператору на законных
                основаниях, в том числе с согласия указанных третьих лиц на
                обработку и передачу персональных данных.
              </Text>
            </li>
          </ul>

          <p className={classes.textIndent}>
            <Text className={classes.sectionText}>
              <strong>
                Перечень персональных данных указанных третьих лиц,
                предоставляемых Оператору на основании данного пункта:
              </strong>
            </Text>
          </p>

          <ul className={classes.markList}>
            <li className={classes.markListItem}>
              <Text>фамилия, имя, отчество (при наличии);</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>паспортные данные;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>скан-копия или копия паспорта;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>адрес регистрации и (или) места жительства;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>ИНН;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                страховой номер индивидуального лицевого счета застрахованного
                лица (СНИЛС);
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>номер мобильного телефона;</Text>
            </li>
            <li className={classes.markListItem}>
              <Text>адрес электронной почты (e-mail).</Text>
            </li>
          </ul>

          <ul className={`${classes.markList} ${classes.inside}`}>
            <li className={classes.markListItem}>
              <Text>
                Я проинформирован, что Оператор вправе осуществлять следующие{" "}
                <strong>действия</strong> с указанными выше персональными
                данными путём смешанной (автоматизированной и
                неавтоматизированной): сбор, запись, систематизацию, накопление,
                хранение, уточнение (обновление, изменение), извлечение,
                использование, передачу (предоставление, доступ), обезличивание,
                блокирование, удаление, уничтожение.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Даю согласие на предоставление моих персональных данных (файлы
                сookie) как Пользователя Сайта компании, выполняющей работы по
                созданию (включая мероприятия по доработкам) Сайта и оказывающим
                услуги по техническому сопровождения Сайта – Яндекс.Метрика.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Оператор вправе поручить обработку моих персональных данных с
                правами осуществлять все действия включая сбор, систематизацию,
                накопление, хранение, обновление, изменение, использование,
                обезличивание, блокирование, уничтожение третьему лицу
                (обработчику), ответственному за обеспечение будущей обратной
                связи, на основании соглашения о поручении обработки
                персональных данных, если это не противоречит законодательству
                Российской Федерации, обеспечивающих их защиту от
                несанкционированного доступа, при условии, что их прием и
                обработка будет осуществляться лицом, обязанным сохранять
                конфиденциальность.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Я осведомлен о праве на доступ к своим персональным данным в
                порядке, определенном статьей 14 Федерального закона от
                27.07.2006 №152-ФЗ «О персональных данных».
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Срок, в течение которого действует согласие: в течение всего
                срока взаимодействия с Оператором посредством личного кабинета
                на платформе https://tatbg.ru/. Согласие может быть отозвано
                мной в любое время путём подачи Оператору заявления.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Персональные данные субъекта подлежат хранению в течение сроков,
                установленных законодательством Российской Федерации.
                Персональные данные уничтожаются: по достижению целей обработки
                персональных данных; при ликвидации или реорганизации оператора;
                на основании письменного обращения субъекта персональных данных
                с требованием о прекращении обработки его персональных данных.
                Оператор прекратит обработку таких персональных данных в течение
                10 (десяти) рабочих дней со дня получения обращения, о чем будет
                направлено письменное уведомление субъекту персональных данных в
                течение 10 (десяти) рабочих дней.
              </Text>
            </li>
            <li className={classes.markListItem}>
              <Text>
                Я проинформирован, что Согласие может быть отозвано мной в любое
                время одним из следующих способов:
              </Text>

              <ul className={classes.markList}>
                <li className={classes.markListItem}>
                  <Text>
                    посредством направления соответствующего заявления заказным
                    письмом с уведомлением о вручении по адресу: 420029,
                    Республика Татарстан, г Казань, ул Сибирский Тракт, зд. 34
                    к. 1, помещ. 1002 офис 1;
                  </Text>
                </li>
                <li className={classes.markListItem}>
                  <Text>
                    посредством направления соответствующего заявления в форме
                    электронного документа (скан-копия, фотокопия документа).
                    Документ должен быть направлен с адреса моей электронной
                    почты по адресу электронной почтые{" "}
                    <a
                      href="mailto:support@tatbg.ru"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      support@tatbg.ru.
                    </a>
                    ;
                  </Text>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </LoginFormLayout>
  );
}
